module.exports = __webpack_public_path__ + "img/sample3.ac8d82c9.jpg";